import Vue from 'vue'
import VueRouter from 'vue-router'
import * as RouteComponents from './route-components'

Vue.use(VueRouter)

const routes = [
  // cms 二级页
  {
    path: '/cms/:pageId',
    name: 'cms',
    component: RouteComponents.cms
  },
  // 摇钱树（活动页面）
  {
    path: '/money_tree',
    name: 'money_tree',
    component: RouteComponents.moneyTree
  },
  // 新秒杀列表
  {
    path: '/seckillNew',
    name: 'seckillNew',
    component: RouteComponents.seckillNew
  },
  {
    path: '/app_download',
    name: 'app_download',
    component: RouteComponents.appDownload,
    alias: '/'
  },
  {
    path: '/supplier_app_download',
    name: 'supplier_app_download',
    component: RouteComponents.supplierAppDownload
  },
  // 相似商品
  {
    path: '/similar_goods',
    name: 'similar_goods',
    component: RouteComponents.similarGoods
  },
  // 领券中心
  {
    path: '/coupon_center',
    name: 'coupon_center',
    component: RouteComponents.couponCenter
  },

  // 账单 - 首页
  {
    path: '/bill_index',
    name: 'billIndex',
    component: RouteComponents.billIndex
  },
  // 账单 - 导出
  {
    path: '/bill_export',
    name: 'billExport',
    component: RouteComponents.billExport
  },
  // 账单 - 导出
  {
    path: '/bill_export_list',
    name: 'billExportList',
    component: RouteComponents.billExportList
  },
  // 我的取货码
  {
    path: '/receive_number',
    name: 'receiveNumber',
    component: RouteComponents.receiveNumber
  },
  // 冻品专区（业务大部分已经替换到 cms 了）
  {
    path: '/category_area/:category',
    name: 'category_area',
    component: RouteComponents.categoryArea
  },
  // 活动聚合页面
  {
    path: '/activity_goods',
    name: 'activityGoods',
    component: RouteComponents.activityGoods
  },
  // 配送单列表
  // {
  //   path: '/deliver_order_list',
  //   name: 'deliverOrderList',
  //   component: RouteComponents.deliverOrderList
  // },
  // 配送单详情
  {
    path: '/deliver_order_detail',
    name: 'deliverOrderDetail',
    component: RouteComponents.deliverOrderDetail
  },
  // pop店铺首页
  {
    path: '/pop_index',
    name: 'popIndex',
    component: RouteComponents.popIndex
  },
  // 商家资质
  {
    path: '/pop_qualification',
    name: 'popQualification',
    component: RouteComponents.popQualification
  },
  // 营业执照
  {
    path: '/pop_license',
    name: 'popLicense',
    component: RouteComponents.popLicense
  },
  // 商家经营信息
  {
    path: '/pop_personShopInfo',
    name: 'popPersonShopInfo',
    component: RouteComponents.popPersonShopInfo
  },
  // 个人清单
  {
    path: '/personList',
    name: 'personList',
    component: RouteComponents.personList
  },
  // 个人清单 - 基本信息
  {
    path: '/personList/info',
    name: 'personListInfo',
    component: RouteComponents.personListInfo
  },
  // 运费相关
  {
    path: '/shipping-fee',
    name: 'my-shipping-fee-list',
    component: RouteComponents.shippingFeeList
  },
  {
    path: '/shipping-fee-detail',
    name: 'my-shipping-fee-detail',
    component: RouteComponents.shippingFeeDetail
  },
  {
    path: '/shipping-fee-rules',
    name: 'shipping-fee-rules',
    component: RouteComponents.shippingFeeRules
  },
  // 热销榜
  {
    path: '/hotSaleList',
    name: 'hotSaleList',
    component: RouteComponents.hotSaleList
  },
  // 钥匙管理
  {
    path: '/user-center/key',
    name: 'key',
    component: RouteComponents.key
  },
  // 红包雨
  {
    path: '/red-package-rain',
    name: 'red-package-rain',
    component: RouteComponents.redPackageRain
  },
  // 检疫证明
  {
    path: '/quarantine-list',
    name: 'quarantine-list',
    component: RouteComponents.quarantineList
  },
  {
    path: '/quarantine',
    name: 'quarantine',
    component: RouteComponents.quarantine
  },
  // 新品提报首页
  {
    path: '/new-good-req/list',
    name: 'newGoodReqList',
    component: RouteComponents.newGoodReqList
  },
  // 进行新品提报-form页面
  {
    path: '/new-good-req/add',
    name: 'newGoodReqAdd',
    component: RouteComponents.newGoodReqAdd
  },
  // 新品提报详情页面
  {
    path: '/new-good-req/detail',
    name: 'newGoodReqDetail',
    component: RouteComponents.newGoodReqDetail
  },
  // 美菜会员-权益
  {
    path: '/member/index',
    name: 'memberIndex',
    component: RouteComponents.memberIndex
  },
  // 美菜会员-省钱明细
  {
    path: '/member/saving',
    name: 'memberSaving',
    component: RouteComponents.memberSaving
  },
  // 美菜会员-购买列表
  {
    path: '/member/buyList',
    name: 'memberBuyList',
    component: RouteComponents.memberBuyList
  },
  // 美菜会员-购买详情
  {
    path: '/member/buyDetail',
    name: 'memberBuyDetail',
    component: RouteComponents.memberBuyDetail
  },
  // 取消订单
  {
    path: '/cancelorder',
    name: 'cancelorder',
    component: RouteComponents.cancelOrder
  },
  // 我的配送单
  {
    path: '/deliverOrder/list',
    name: 'deliverOrderList',
    component: RouteComponents.deliverOrderList
  },
  // 服务费
  {
    path: '/serviceFee/index',
    name: 'serviceFee',
    component: RouteComponents.serviceFee
  },
  {
    path: '/fee-rules',
    name: 'feeRules',
    component: RouteComponents.feeRules
  },
  // 检测报告
  {
    path: '/inspect-report',
    name: 'inspectReport',
    component: RouteComponents.inspectReport
  },
  // 会员积分
  {
    path: '/member-integral',
    name: 'memberIntegral',
    component: RouteComponents.memberIntegral
  },
  // 会员积分明细
  {
    path: '/member-integral-detail',
    name: 'memberIntegralDetail',
    component: RouteComponents.memberIntegralDetail
  },
  // 会员兑换历史
  {
    path: '/member-integral-history',
    name: 'memberIntegralHistory',
    component: RouteComponents.memberIntegralHistory
  },
  // 付费劵包
  {
    path: '/member-couponpack',
    name: 'memberCouponpack',
    component: RouteComponents.memberCouponpack
  },
  // 付费劵包购买历史
  {
    path: '/member-couponpack-history',
    name: 'memberCouponpackHistory',
    component: RouteComponents.memberCouponpackHistory
  },
  // 付费劵包购买详情
  {
    path: '/member-couponpack-detail',
    name: 'memberCouponpackDetail',
    component: RouteComponents.memberCouponpackDetail
  },
  // 付费劵包购买成功
  {
    path: '/member-couponpack-success',
    name: 'memberCouponpackSuccess',
    component: RouteComponents.memberCouponpackSuccess
  },
  // 购物车活动规则
  {
    path: '/cart-activity-rule',
    name: 'cartActivityRule',
    component: RouteComponents.cartActivityRule
  },
  // 廉洁协议
  {
    path: '/user-protocol',
    name: 'userprotocol',
    component: RouteComponents.userprotocol
  },
  // 市调活动
  {
    path: '/market-research',
    name: 'marketResearch',
    component: RouteComponents.marketResearch
  },
  // 市调活动任务明细
  {
    path: '/task-detail',
    name: 'taskDetail',
    component: RouteComponents.taskDetail
  },
  // 市调活动记录
  {
    path: '/task-record',
    name: 'taskRecord',
    component: RouteComponents.record
  },
  // 市调活动记录
  {
    path: '/user-change-price',
    name: 'userChangePrice',
    component: RouteComponents.userChangePrice
  },
  {
    path: '/recharge-coupon',
    name: 'rechargeCoupon',
    component: RouteComponents.rechargeCoupon
  },
  {
    path: '/goods-rank',
    name: 'goodsRank',
    component: RouteComponents.goodsRank
  },
  {
    path: '/demand-word-rank',
    name: 'demandWordRank',
    component: RouteComponents.demandWordRank
  },
  {
    path: '/activity-area',
    name: 'activityArea',
    component: RouteComponents.activityArea
  },
  {
    path: '/good-config',
    name: 'goodConfig',
    component: RouteComponents.goodConfig
  },
  {
    path: '/stall-list',
    name: 'stallList',
    component: RouteComponents.stallList
  },
  {
    path: '/stall-edit',
    name: 'stallEdit',
    component: RouteComponents.stallEdit
  },
  {
    path: '/home-goods',
    name: 'homeGoods',
    component: RouteComponents.homeGoods
  },
  {
    path: '/key-box',
    name: 'keyBox',
    component: RouteComponents.keyBox
  },
  {
    path: '/key-box-detail',
    name: 'keyBoxDetail',
    component: RouteComponents.keyBoxDetail
  },
  {
    path: '/delivery-order-config',
    name: 'deliveryOrderConfig',
    component: RouteComponents.deliveryOrderConfig
  },
  {
    path: '/platform-rules',
    name: 'platformRules',
    component: RouteComponents.platformRules
  },
  {
    path: '*',
    name: 'app_download',
    component: RouteComponents.appDownload
  }
]

export const router = new VueRouter({
  routes
})
